<template>
  <v-container class="modern-config-view pb-12" fluid>
    <!-- Premium Global Header -->
    <v-row class="mb-8 align-center px-4 pt-4">
      <v-col cols="12" md="8">
        <div class="d-flex align-center flex-wrap gap-3">
          <v-avatar color="primary" size="48" class="mr-4 shadow-sm">
            <v-icon color="white">fas fa-cog</v-icon>
          </v-avatar>
          <div>
            <h1 class="text-h4 font-weight-black primary--text mb-0">Configuración Comercial</h1>
            <div class="caption grey--text font-weight-bold text-uppercase tracking-widest mt-1">Gestión de Maestros para Cotizaciones y Ventas</div>
          </div>
        </div>
      </v-col>
      <v-col cols="12" md="4" class="text-right">
        <v-btn @click.prevent="$router.push('/sales')" text class="grey--text text--darken-1 font-weight-bold">
          <v-icon left small>fas fa-chevron-left</v-icon>
          Volver a Ventas
        </v-btn>
      </v-col>
    </v-row>

    <v-card outlined class="modern-card elevation-0 overflow-hidden">
      <v-tabs 
        v-model="tab"
        background-color="grey lighten-5"
        color="primary"
        grow
        class="border-bottom"
        slider-size="4"
      >
        <v-tab class="text-none font-weight-bold py-4">
          <v-icon left small>fas fa-map-marker-alt</v-icon>
          Origen de Cotización
        </v-tab>
        <!-- Espacio para futuros mantenedores -->
      </v-tabs>

      <v-tabs-items v-model="tab">
        <v-tab-item class="pa-6 bg-white">
          <origins/>
        </v-tab-item>
      </v-tabs-items>
    </v-card>
  </v-container>
</template>

<script>
import Origins from './Origins.vue';

export default {
  name:'SalesNoteConfiguration',
  components:{Origins},
  data() {
    return {
      tab: null,
    }
  },
}
</script>

<style scoped>
.modern-config-view {
  background-color: #f8fafc;
  min-height: 100vh;
  font-family: 'Outfit', sans-serif !important;
}

.modern-card {
  border: 1px solid rgba(0,0,0,0.08) !important;
  border-radius: 12px !important;
  background: white;
}

.border-bottom { 
  border-bottom: 1px solid rgba(0,0,0,0.08) !important; 
}

.text-none { 
  text-transform: none !important; 
}

.tracking-widest { 
  letter-spacing: 2px; 
}

.shadow-sm { 
  box-shadow: 0 4px 12px rgba(0,0,0,0.03) !important; 
}

.gap-3 { 
  gap: 12px; 
}

.bg-white {
  background-color: white !important;
}
</style>